// extracted by mini-css-extract-plugin
export default {"skills":"Skills_skills__8lQaw","skill":"Skills_skill__FuEFV","iconWrap":"Skills_iconWrap__shPKq","skillName":"Skills_skillName__7JUU7"};